var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7502 2V2.1817C17.7582 3.02764 20.6856 6.71962 20.4016 10.9801L20.2459 13.3158C20.0898 15.6571 20.952 17.9517 22.6112 19.6109C23.1238 20.1235 22.7607 21 22.0358 21H15.6154C15.1778 22.5856 13.725 23.75 12.0002 23.75C10.2755 23.75 8.82267 22.5856 8.38505 21H1.96476C1.23982 21 0.876765 20.1235 1.38938 19.6109C3.04856 17.9517 3.91075 15.6571 3.75467 13.3158L3.59895 10.9801C3.31492 6.71965 6.24228 3.02768 10.2502 2.18172V2C10.2502 1.0335 11.0337 0.25 12.0002 0.25C12.9667 0.25 13.7502 1.0335 13.7502 2ZM9.98412 21C10.3523 21.7409 11.1168 22.25 12.0002 22.25C12.8837 22.25 13.6482 21.7409 14.0164 21H9.98412ZM18.7492 13.216C18.5988 15.4725 19.247 17.6925 20.5526 19.5H3.44792C4.75356 17.6925 5.40178 15.4725 5.25134 13.216L5.09563 10.8803C4.82936 6.88619 7.99732 3.5 12.0003 3.5C16.0032 3.5 19.1712 6.8862 18.9049 10.8803L18.7492 13.216Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsBell);
export default __webpack_public_path__ + "static/media/notificationsBell.34c71a7b.svg";
export { ForwardRef as ReactComponent };